import { styled } from '@compiled/react';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { Stack } from '@atlaskit/primitives/compiled/stack';
import type { PopupComponentProps } from '@atlaskit/popup/types';
import { token } from '@atlaskit/tokens';

import { i18n } from './i18n.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PopupWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':focus': {
		outline: 'none',
	},
	borderRadius: token('radius.large'),
	boxShadow: token('elevation.shadow.overlay'),
	zIndex: 1,
});

export const CustomPopupContainer: React.ForwardRefExoticComponent<
	PopupComponentProps & React.RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, PopupComponentProps>(({ children, ...props }, ref) => {
	const intl = useIntl();

	return (
		<PopupWrapper
			{...props}
			ref={ref}
			role="dialog"
			aria-label={intl.formatMessage(i18n.quickSummaryLabel)}
		>
			<Stack space="space.150">{children}</Stack>
		</PopupWrapper>
	);
});
